import * as angular from 'angular';
import { downgradeInjectable } from '@angular/upgrade/static';
import { Actions } from '@ngrx/effects';

export const DowngradedNgrxEffectsModule = angular
  .module('downgraded-ngrx-effects', [])
  .factory('actions$', downgradeInjectable(Actions)).name;
